import React from 'react'
import './OricStaff.css'
import profile from "../assets/profile-bg.jpg"


const Testimonials = () => {
  return (
    <>
 

    <h1>Oric Staff</h1>
    <div className="card-container">
        <div className="Staffcard" id="card1">
            <img src={profile} alt="Teacher 1"/>
            <h2>Ms. Zohra Shahzad</h2>
            <p>Manager University Linkages, ORIC</p>
            <p>Email: qazizohra2480@gmail.com</p>
            <p>Phone:  091-9224818</p>
        </div>
       
        <div className="Staffcard" id="card3">
            <img src={profile} alt="Teacher 3"/>
            <h2>Ms. Sana Jamil</h2>
            <p>Deputy Director ORIC</p>
            <p>sanajamil@sbbwu.edu.pk</p>
            <p>091- 9224794</p>
        </div>
        <div className="Staffcard" id="card4">
            <img src={profile} alt="Teacher 4"/>
            <h2>Ms. Sadaf Ijaz</h2>
            <p>Office Assistant</p>
            <p>Email: 	oric@sbbwu.edu.pk</p>
            <p>Phone:  091-9224794</p>
        </div>
    </div>


          
    </>
  )
}

export default Testimonials
